import { ErrorCode } from '@golden/gdk-admin'


export const SENTRY_IGNORE_CODES = [
  // issue: rate limited by repeated API calls (https://universetech.slack.com/archives/C01E9HY7GCE/p1780293728674739)
  ErrorCode.API_RATE_LIMIT_EXCEEDED
]
